export default "__VITE_ASSET__CuDD42ZM__"